<page-heading [title]="'billing.home.title' | translate"></page-heading>

<billing-details-component></billing-details-component>